/**
 * © 2025 Little Shilling, Inc.
 * Shon Little
 * Created: 2025-01-11
 */

import { IconButton, Tooltip } from '@mui/material';
import { Brightness4, Brightness7 } from '@mui/icons-material';
import { useTheme } from '../../contexts/ThemeContext';

/**
 * Theme toggle component for switching between light and dark modes.
 * @returns Theme toggle button component
 */
const ThemeToggle: React.FC = () => {
  const { toggleMode, isDark } = useTheme();

  return (
    <Tooltip title={`Switch to ${isDark ? 'light' : 'dark'} mode`}>
      <IconButton
        onClick={toggleMode}
        color="inherit"
        aria-label={`Switch to ${isDark ? 'light' : 'dark'} mode`}
        sx={{
          transition: 'transform 0.2s ease-in-out',
          '&:hover': {
            transform: 'scale(1.1)',
          },
        }}
      >
        {isDark ? <Brightness7 /> : <Brightness4 />}
      </IconButton>
    </Tooltip>
  );
};

export default ThemeToggle;
